/**
 * 系统管理 用户管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>【{{station_name}}】白名单用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="手机号">
        <el-input size="small" v-model="formInline.mobile" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column sortable prop="id" label="序号" >
      </el-table-column>
      <el-table-column sortable prop="nickname" label="昵称" >
        <template slot-scope="scope">
          {{  scope.row.nickname ? scope.row.nickname  :'-'}}
        </template>
      </el-table-column>
      <el-table-column sortable prop="tel" label="手机号" >
      </el-table-column>
      <el-table-column sortable prop="usable_fund" label="账户余额(元)" >
        <template slot-scope="scope">
          {{  scope.row.usable_fund /100}}
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="plate" label="车牌信息" >
        <template slot-scope="scope">
          {{scope.row.plate}}
        </template>
      </el-table-column> -->
      <el-table-column sortable prop="created_at" label="注册时间" >
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="300">
        <template slot-scope="scope">
          <router-link :to="{  path: '/order/Charge', query: {tel: scope.row.tel}}">
            <el-button type="success" size="small" >查看充电记录</el-button>
          </router-link>
          <router-link :to="{  path: '/order/Recharge', query: {mobile: scope.row.tel}}">
            <el-button type="success" size="small" >查看充值记录</el-button>
          </router-link>
          <el-button size="mini" type="danger" @click="deleteWhiteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :title="title" :visible.sync="addFormVisible" width="50%" @click="closeDialog">
      <el-form label-width="120px" :model="addForm"  ref="addForm">
        <el-form-item label="手机号:">
          <el-input size="small" v-model="addForm.tel"  placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('addForm')">保存</el-button>
      </div>
    </el-dialog>
</div>
</template>

<script>
// 导入请求方法
import { getStationNames } from '../../api/station'
import { getUser,updateAppUser,addWhiteUser,deleteWhiteUser } from '../../api/price'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      addFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      addForm: {
        station_id:'',
        tel:'',
      },
      station_id:this.$route.query.station_id,
      station_name:this.$route.query.station_name,
      // 请求数据参数
      formInline: {
        page: 1,
        limit: 10,
        mobile: '',
        station_id:this.$route.query.station_id
      },
      station_names:[],
      //用户数据
      listData: [],

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getStationNames()
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    closeDialog() {
      this.addFormVisible = false
    },
    getStationNames(){
      getStationNames().then(res => {
        if (res.code == 0) {
            this.station_names = res.data
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
     //显示编辑界面
     handleEdit: function(index, row) {
      this.addFormVisible = true
        this.title = '添加'
        this.addForm =  {
          station_id:this.$route.query.station_id,
          tel:'',
        }
    },
    // 获取数据方法
        // 获取公司列表
    getdata() {
      this.loading = true
      getUser(this.formInline).then(res => {
        if (res.code == 0) {
          this.loading = false
          this.listData = res.data.data
          this.pageparm.currentPage = res.data.current_page
          this.pageparm.pageSize = res.data.per_page
          this.pageparm.total = res.data.total
        } else {
          this.$message.error(res.message)
          return false
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    submitForm(addData) {
      this.$refs[addData].validate(valid => {
        if (valid) {
            addWhiteUser(this.addForm)
            .then(res => {
              this.addFormVisible = false
              this.loading = false
              if (res.code ==0) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.addFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
     // 删除公司
     deleteWhiteUser(index, row) {
      this.$confirm('此操作将删除该场白名单用户, 是否继续?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id:row.id,
            station_id:this.station_id
          }
          deleteWhiteUser(params)
            .then(res => {
              if (res.code == 0 ) {
                this.$message({
                  type: 'success',
                  message: '已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },





  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/system/WhiteUser.vue